import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { NavLink } from 'react-router-dom';
import Button from 'material-ui/Button';
import { ListItem } from 'material-ui/List';
import classnames from 'classnames';

const styles = theme =>({
  button: theme.mixins.gutters({
    borderRadius: 0,
    justifyContent: 'flex-start',
    textTransform: 'none',
    width: '100%',
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shortest,
    }),
    '&:hover': {
      textDecoration: 'none',
    },
  }),
  navLinkButton: {
    color: theme.palette.text.secondary,
    textIndent: 24,
    fontSize: 13,
  },
  activeButton: {
    color: theme.palette.text.primary,
  }
});

export class NavItem extends Component{
  render(){
    const { children, classes, onClick, path, disabled } = this.props;
    return (
      <ListItem>
        <Button component={ NavLink }
          disabled={disabled}
          to={path}
          className={ classnames(classes.button, classes.navLinkButton) }
          activeClassName={ classes.activeButton }
          disableRipple
          onClick={ onClick }
        >
          { children }
        </Button>
      </ListItem>
    );
  }
}

NavItem.propTypes = {
  classes:  PropTypes.object.isRequired,
  path:     PropTypes.string,
  onClick:  PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default withStyles(styles)(NavItem);



// WEBPACK FOOTER //
// ./src/components/NavItem.js